<template>
    <a class="article item" :href="post.source" target="_blank">
        <img :src="post.thumbnail.url" :alt="post.thumbnail.alt" :title="post.thumbnail.alt">
        <div class="article-body">
            <h2 class="article-title">
                {{ post.title }}
            </h2>
            <p class="article-content" v-html="post.content"></p>
            <footer class="article-info">
                <span>{{ post.date }}</span>
                <span>{{ post.source_name }}</span>
            </footer>
        </div>
    </a>
</template>

<script>
	export default {
		props: [
			"post"
		],
	}
</script>

<style lang="scss" scoped>
    @import "article";
    $margin: .75rem;
    .article.item {
        width: calc(100% - #{$margin * 2});
        margin: $margin;
        height: auto !important;
        display: block;
    }
    @media screen and (min-width: 40em) {
        .article.item {
            width: calc(50% - #{$margin * 2});
        }
    }

    @media screen and (min-width: 64em) {
        .article.item {
            width: calc(33% - #{$margin * 2});
        }
    }
</style>


// WEBPACK FOOTER //
// news-external.vue?0884d4ef